import service from './service'
import { useLocaleStoreWithOut } from '@/stores/modules/locale'
import { getTokenCache } from '@/storage/user'
import { TOKEN_KEY } from '@/constants'
import { getSign } from '@/utils/getSign'

const request = option => {
  const localeStore = useLocaleStoreWithOut()
  const { url, method, params, data, headers, responseType } = option
  const currentLocale = localeStore.getCurrentLocale
  const token = getTokenCache()
  const defaultHeaders = {
    lang: currentLocale.lang,
    ...headers
  }

  if (token) {
    defaultHeaders[TOKEN_KEY] = token
  }

  return service.request({
    url: url,
    method,
    params: method === 'get' ? getSign(params) : params,
    data: method === 'post' ? getSign(data) : data,
    responseType: responseType,
    headers: {
      ...defaultHeaders
    }
  })
}

export default {
  get: option => {
    return request({ method: 'get', ...option })
  },
  post: option => {
    return request({ method: 'post', ...option })
  },
  delete: option => {
    return request({ method: 'delete', ...option })
  },
  put: option => {
    return request({ method: 'put', ...option })
  },
  cancelRequest: url => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}
